import {
  VersionReportPageConfig,
  VersionReportPageType,
  VersionReportVersionPageEntity,
  VersionReportVersionPageRowEntity,
} from '../../../../../../../domain/entity/version-report/VersionReportVersionEntity'

export type VersionReportVersionPageFormModel = {
  // 新規ページは null (configure API で BE 側が uuid 発番)
  uuid: string | null
  lockVersion: number | null
  pageNumber: number
  pageType: VersionReportPageType
  pageTitle: string
  leadSentence: string | undefined
  config: VersionReportPageConfig
  rows: VersionReportVersionPageRowEntity[]
}

export const toEntityForValidation = (
  page: VersionReportVersionPageFormModel
): Pick<
  VersionReportVersionPageEntity,
  'pageTitle' | 'pageType' | 'config'
> => ({
  pageTitle: page.pageTitle,
  pageType: page.pageType,
  config: page.config,
})
